<template>
    <b-modal
        id="modal-plansalesorders"
        size="xl"
        ref="modal"
        :title="this.formtitle"
        :visible="visible"
        @hidden="hide"
        @ok="handleOk"
    >
        <div class="form-inline">
            <period-selector
                style="width: 85%"
                v-model="selectDays"
                v-bind:periodDays="periodeDagen"
                v-bind:forceToday="true"
                @change="setNewDates"
            />
            <b-button @click="loadData()" class="bgc_aux_normal"
                ><font-awesome-icon icon="arrow-down" size="1x" />&nbsp;{{
                    $t('com_show', { ns: 'common' })
                }}
            </b-button>
        </div>
        <div v-if="showFilter">
            <b-row no-gutters>
                <b-col lg="6" class="my-1">
                    <b-form-group
                        :label="$t('com_filter', { ns: 'common' })"
                        label-for="filter-input"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0"
                    >
                        <b-input-group size="sm">
                            <b-form-input
                                id="filter-input"
                                v-model="filter"
                                type="search"
                                :placeholder="
                                    $t('com_typetosearch', {
                                        ns: 'common'
                                    })
                                "
                            ></b-form-input>

                            <b-input-group-append>
                                <b-button
                                    :disabled="!filter"
                                    @click="filter = ''"
                                    >{{
                                        $t('com_wis', { ns: 'common' })
                                    }}</b-button
                                >
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>

                <b-col lg="6" class="my-1">
                    <b-form-group
                        :label="$t('com_perpagina', { ns: 'common' })"
                        label-for="per-page-select"
                        label-cols-sm="6"
                        label-cols-md="4"
                        label-cols-lg="3"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0"
                    >
                        <b-form-select
                            id="per-page-select"
                            v-model="perPage"
                            :options="pageOptions"
                            size="sm"
                        ></b-form-select>
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            align="fill"
                            size="sm"
                            class="my-0"
                        ></b-pagination>
                    </b-form-group>
                </b-col>
            </b-row>
        </div>
        <b-alert v-model="showDismissibleAlert" variant="danger" dismissible>
            {{ alertText }}
        </b-alert>

        <b-table
            striped
            responsive
            :fields="visibleFields"
            :items="displayList"
            stacked="md"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            small
            show-empty
            :empty-text="$t('com_geen_data', { ns: 'common' })"
            multi
            selectable
            ref="selectableTable"
            @row-selected="onRowSelected"
        >
        </b-table>
        <p>
            <b-button size="sm" v-if="erisselected" @click="clearSelected">{{
                $t('com_wisselectie', {
                    ns: 'common'
                })
            }}</b-button>
        </p>
    </b-modal>
</template>

<script>
import _ from 'lodash';
import DateHelper from '../../models/DateHelper';
import Helper from '../../models/Helper';
import { loadItem } from '../../models/DataHelper';
import PeriodSelector from '../components/PeriodSelector.vue';

export default {
    name: 'PlanDeliveryForm',
    data: function () {
        return {
            totalRows: 1,
            currentPage: 1,
            perPage: 20,
            pageOptions: [10, 20, 40, { value: 100, text: '100' }],
            filter: null,
            filterOn: [],
            showDismissibleAlert: false,
            alertText: '',
            selectDays: null,
            van: null,
            tot: null,
            dag: 'day',
            isDagInfo: true,
            periodeDagen: 1,
            displayFilterCount: 2,
            orderList: [],
            selected: []
        };
    },
    components: {
        PeriodSelector
    },
    model: {
        prop: 'visible',
        event: 'hide'
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        lijst: {
            type: Array,
            default: () => []
        },
        refresh: {
            type: Number,
            default: 0
        }
    },
    watch: {
        refresh() {
            this.loadData();
        }
    },
    computed: {
        formtitle() {
            return this.$t('com_salesorders', { ns: 'common' });
        },
        erisselected() {
            return this.selected.length > 1;
        },
        showFilter(){
            return this.displayList
                ? this.displayList.length > this.displayFilterCount
                : false;
        },
        visibleFields() {
            const fieldsInit = [
                { key: 'actions', label: ' ', visible: false },
                { key: 'id', label: 'Id', sortable: false, visible: false },
                {
                    key: 'klant',
                    label: this.$t('com_klant', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'klantRef',
                    label: this.$t('log_reference', { ns: 'logistics' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'product',
                    label: this.$t('com_product', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'vorm',
                    label: this.$t('prod_vorm', { ns: 'production' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'productiedatum',
                    label: this.$t('log_optdatum', { ns: 'logistics' }),
                    sortable: true,
                    visible: true,
                    formatter: this.displayDate
                },
                {
                    key: 'afleverdatum',
                    label: this.$t('log_leverdatum', { ns: 'logistics' }),
                    sortable: true,
                    visible: true,
                    formatter: this.displayDate
                },
                {
                    key: 'ol_requestedamount',
                    label: this.$t('prod_requested', { ns: 'production' }),
                    sortable: true,
                    visible: true
                }
            ];
            return fieldsInit.filter((field) => field.visible);
        },
        displayList() {
            const lijst = this.orderList;
            return lijst;
        }
    },
    methods: {
        showAlert(tekst) {
            this.alertText = tekst;
            this.showDismissibleAlert = true;
        },
        displayDate(value) {
            return DateHelper.convertedToDate(value, false);
        },
        setNewDates(selDates) {
            const refreshData =
                this.van != selDates.van ||
                this.tot != selDates.tot ||
                this.dag != selDates.dag;
            this.van = selDates.van;
            this.tot = selDates.tot;
            this.dag = selDates.dag;
            this.isDagInfo = selDates.dag == 'day';
            if (refreshData) this.loadData();
        },
        async loadData() {
            const selectionData = {
                from: DateHelper.localDateToUTC(this.van),
                until: DateHelper.localDateToUTC(this.tot)
            };
            this.orderList = await loadItem(
                'salesorder/loadSalesOrderInfo',
                selectionData,
                this.$t
            );
            this.totalRows = this.orderList ? this.orderList.length : 0;
        },
        hide() {
            this.$emit('hide');
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        onRowSelected(items) {
            this.selected = items;
            this.checkFormValidity();
        },
        clearSelected() {
            this.$refs.selectableTable.clearSelected();
        },
        checkFormValidity() {
            if (this.selected.length === 0) {
                this.showAlert(this.$t('com_selectitem', { ns: 'common' }));
                return false;
            }
            if (Helper.distinctListKey(this.selected, 'klantRef').length > 1) {
                this.showAlert(
                    this.$t('com_selectonlyoneref', { ns: 'common' })
                );
                return false;
            }
            for (const item of this.selected) {
                if (!item.ol_requestedamount || item.ol_requestedamount <= 0) {
                    this.showAlert(
                        this.$t('com_onereference', { ns: 'common' })
                    );
                    return false;
                }
            }
            return true;
        },
        handleOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault();
            // Trigger submit handler
            this.handleSubmit();
        },
        handleSubmit() {
            // Exit when the form isn't valid
            if (!this.checkFormValidity()) {
                return;
            }
            this.$emit('addItems', this.selected);
            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-plansalesorders');
            });
        }
    },
    mounted() {
        this.totalRows = this.orderList ? this.orderList.length : 0;
    },
    created() {
        this.orderList = this.lijst;
    }
};
</script>

<style scoped>
::v-deep .table > tbody > tr.b-table-row-selected,
::v-deep .table > tbody > tr.b-table-row-selected > td,
::v-deep .table > tbody > tr.b-table-row-selected > th {
    background-color: #00a1de;
    color: ghostwhite !important;
}
.overflow-class /deep/ .dropdown-menu {
    max-height: 200px;
    overflow-y: auto;
}
</style>
